import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ProjectPane from 'components/projects/ProjectPane';
import BasePage from 'components/UI/BasePage';
import { useGetProjectsQuery } from 'services/projects/api';
import links, { matchesLinkKey } from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const ProjectPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { slug } = useParams<{ slug: string; }>();
  const { data: projects } = useGetProjectsQuery();
  const project = projects && projects.find(item => matchesLinkKey(item, slug));

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{`${t('projects')}${project?.name ? ` - ${project.name}` : ''}`}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.paths.projects, navigate), label: t('projects') },
            { label: project?.name ?? '' },
          ]}
        />
        {
          slug && (
            <ProjectPane
              id={slug}
              showExpandIcon={false}
            />
          )
        }
      </BasePage>
    </>
  );
};

export default ProjectPage;
